import { render, staticRenderFns } from "./Upslip.vue?vue&type=template&id=7d816ea1"
import script from "./Upslip.vue?vue&type=script&lang=js"
export * from "./Upslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports